import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ApiService} from '../../../services/api.service';
import {LoginService} from '../../../services/login.service';
import {NotificationsService} from "angular2-notifications";
import {BarChartComponent} from '../zoomView/bar-chart/bar-chart.component';
import {ModalService} from "../../../services/modalService/modal.service";
import {UtilsService} from '../../../services/utils.service';
import { TranslateService } from '@ngx-translate/core';
import { BackendTranslateService } from '../../../helper/backend-translate.service';
@Component({
  selector: 'app-features-duration',
  templateUrl: './features-duration.component.html',
  styleUrls: ['./features-duration.component.css', '../myreports.component.css']
})
export class FeaturesDurationComponent implements OnInit {

  ruid: string;
  public barChartData = [];
  public options = {
    height: 400,
    titlePosition: 'out',
    chartArea: {height: '100%', width: '60%', left: 150},
    vAxis: {title: this.translate.instant('reports.featureDuration.features')},
    hAxes: {
      0: {title: this.translate.instant('reports.featureDuration.usage'), formatter: 'minsToHours'},
      1: {title: this.translate.instant('reports.featureDuration.noSession')}
    },
    series: {
      0: {targetAxisIndex: 0},
      1: {targetAxisIndex: 1},
      2: {targetAxisIndex: 1}
    },
    colors: ['#f44336', '#3f51b5'],
    showAnnotations: true
  };
  isloggedIn: boolean = false;
  isLicense: string;
  featureData: any = {};

  chartError = false;

    constructor(private apiService: ApiService,
              private loginService: LoginService,
              private route: ActivatedRoute,
              private notifications: NotificationsService,
              private modalService: ModalService,
              private utilService: UtilsService,
              private translate: TranslateService,
              private backendTranslate: BackendTranslateService) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params.ruid) {
        this.ruid = params.ruid;
        if (this.ruid === 'demo') {
          this.reportsData();
        } else {
          this.loginService.isLoggedIn()
            .subscribe((currentUser) => {
              this.isloggedIn = currentUser.isLoggedIn;
              if (this.isloggedIn) {
                this.apiService.getSummary(this.ruid)
                  .subscribe((res) => {
                    this.isLicense = res.isLicense;
                    if (!res.isLicense) {
                      this.reportsData();
                    }
                  }, (error) => {
                      this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(error, this.translate.instant('reports.invalidRuid')));
                  });
              }
            });
        }
      }
    });
  }

  reportsData() {
    this.apiService.getChartData(this.ruid, 'FEATURE_USAGE')
      .subscribe((res) => {
          this.featureData = res;
          this.featureData.data[0] = this.backendTranslate.translateCollection(this.featureData.data[0]);
          this.barChartData = this.featureData.data;
          this.utilService.updateChartAreaFromData(this.barChartData, this.options);
      }, (error) => {
          this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(error, this.translate.instant('reports.featureFail')));
      });
  }

  zoomView() {
    if (this.barChartData.length === 0) {
        return;
    }
    this.modalService.open(BarChartComponent, {
      title: this.translate.instant('reports.featureDuration.top10'),
      data: {
        chartData: this.featureData,
        isLicense: this.isLicense,
        options: this.options
      }
    }).subscribe();
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/features-duration/features-duration.component.ts